<template>
  <Typeahead
    v-model="counterParty"

    label="Who is the Counterparty? (Business name)"
    placeholder="Start typing to search..."
    :items="allAvailableCounterParties"
    :errors="$page.props.errors.counter_party_id"

    :tolerance="0"

    id-field="id"
    search-field="name"
    display-field="name"
    return-field="id"

    @selected="counterPartySelected"
    @noResults="showAddNewCounterParty"
    @listAppend="showAddNewCounterParty"

    show-list-append
  >
    <template v-slot:item="slotProps">
      <span v-if="slotProps.match.name">{{ slotProps.match.name }}<br /></span>
      <strong v-if="slotProps.match.address"><small>Address: {{ slotProps.match.address }}</small></strong>
      <strong v-if="slotProps.match.registered_number"><small>Phone: {{ slotProps.match.registered_number }}</small></strong>
    </template>

    <template v-slot:noResults>
      <small>We couldn't find a match.</small><br />
      <span class="text-primary">Add a new Counterparty</span>
    </template>

    <template v-slot:listAppend>
      <small>Can't find the correct Counterparty?</small><br />
      <span class="text-primary">Add a new Counterparty</span>
    </template>
  </Typeahead>
</template>

<script>
import Typeahead from '@/Shared/Inputs/NewTypeahead';

export default {
  components: {
    Typeahead,
  },

  props: {
    value: [String, Number],
    organisations: Array,
    counterParties: Array,
  },

  data() {
    return {
      counterParty: null,
      counterPartiesData: this.counterParties,
      newCounterparty: {
        name: '',
        address: '',
        registered_number: '',
      },
      adding: false,
      showAdd: false,
    };
  },

  computed: {
    allAvailableCounterParties() {
      const modifiedOrganisations = this.organisations.map((org) => ({
        id: org.id,
        type: 'App\\Models\\Organisation',
        name: org.name,
      }));

      const modifiedCounterParties = this.counterPartiesData.map((cp) => ({
        id: cp.id,
        type: 'App\\Models\\CounterParty',
        name: cp.name,
        address: cp.address,
        registered_number: cp.registered_number,
      }));

      return [...modifiedOrganisations, ...modifiedCounterParties].filter((org) => org.id);
    },
  },

  methods: {
    counterPartySelected(cp) {
      this.$page.props.errors.counter_party_id = null;

      if (cp) {
        this.showAdd = false;
        this.$emit('input', cp.id);
      } else {
        this.$emit('input', null);
      }
    },

    showAddNewCounterParty(query) {
      this.showAdd = true;
      this.newCounterparty.name = query;
    },

    addCounterparty() {
      this.adding = true;
      window.axios
        .post('/counter-party', this.newCounterparty)
        .then(({ data }) => {
          this.adding = false;
          this.showAdd = false;

          this.newCounterparty.name = '';
          this.newCounterparty.registered_number = '';
          this.newCounterparty.address = '';

          this.counterPartiesData.push(data);
          this.counterParty = data;

          this.$emit('input', data.id);
        })
        .catch((error) => {
          this.adding = false;
          this.errors = error.response.data.errors;
          throw new Error(error);
        });
    },
  },
};
</script>
